const React = require("react")

import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./table-sizer.less"
import StatelessDropDown from "@cirrus/legacy/app-components/form-controls/drop-downs/stateless-drop-down/index.jsx"
import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
var itemsPerPageOptions = [10, 30, 50, 100]
export default createReactClass({
  propTypes: {
    className: PropTypes.string,
    size: PropTypes.number,
    totalCount: PropTypes.number,
    onSizerChange: PropTypes.func,
    isChangeSizeEnabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      isChangeSizeEnabled: true,
    }
  },

  componentWillMount() {
    this.collection = this.getCollection()
  },

  getCollection() {
    return itemsPerPageOptions.map(function (obj) {
      return {
        id: obj,
        title: obj + " item(s)",
      }
    })
  },

  onChange(e, value) {
    this.props.onSizerChange(Number(value))
  },

  render() {
    let className = classnames(styles.sizer, this.props.className)
    let totalFound = appStorage
      .translationFunction("Framework:TotalFound")
      .replace("{0}", this.props.totalCount)
    let show = appStorage.translationFunction("Framework:Show")
    let perPage = appStorage.translationFunction("Framework:PerPage")
    return this.props.isChangeSizeEnabled ? (
      <div className={className}>
        <span className={styles.total} data-qa="table-sizer-total">
          {totalFound} | {show}
        </span>
        <StatelessDropDown
          className={styles.combobox}
          collection={this.collection}
          value={this.props.size}
          onChange={this.onChange}
        />
        <span className={styles.perPage}>{perPage}</span>
      </div>
    ) : (
      <div className={className}>
        <span className={styles.total} data-qa="table-sizer-total">
          {totalFound}
        </span>
      </div>
    )
  },
})
